import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, BellRing } from "lucide-react";
import { BRAND } from "@/constants/compliance";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ eyebrow, title, updated, children, testId }) => (
  <div data-testid={testId} className="bg-[#FAF8F5] min-h-screen grain">
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FAF8F5]/85 border-b border-stone-200/60">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="legal-logo" className="flex items-center gap-2.5">
          <span className="w-8 h-8 rounded-full bg-[#D96B43] text-[#FAF8F5] flex items-center justify-center">
            <BellRing size={14} strokeWidth={2.4} />
          </span>
          <span className="font-display font-extrabold tracking-tight text-[#1E2022]">
            RemindMe <span className="text-[#D96B43]">&</span> Do
          </span>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="flex items-center gap-1.5 text-sm font-medium text-[#575B60] hover:text-[#D96B43] transition-colors"
        >
          <ArrowLeft size={15} /> Back to home
        </Link>
      </div>
    </header>

    <main className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#4A7C59] mb-4"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-[#1E2022] mb-3"
        data-testid={`${testId}-title`}
      >
        {title}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-xs text-[#8A8F98] mb-14"
      >
        Last updated: {updated} · {BRAND.name} · {BRAND.domain}
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.25 }}
        className="space-y-10"
      >
        {children}
      </motion.div>
    </main>
    <Footer />
  </div>
);

export const LegalSection = ({ num, title, children, testId }) => (
  <section data-testid={testId} className="border-t border-[#1E2022]/10 pt-8">
    <div className="flex items-baseline gap-4 mb-4">
      <span className="font-display font-extrabold text-2xl text-[#D96B43]">{num}</span>
      <h2 className="font-display font-bold text-xl sm:text-2xl tracking-tight text-[#1E2022]">
        {title}
      </h2>
    </div>
    <div className="text-sm sm:text-base text-[#575B60] leading-relaxed space-y-3 sm:pl-12">
      {children}
    </div>
  </section>
);
